<template>
	<div v-parallax-fit="parallax" ref="slide26" class="finish">
		<img src="/themes/rise-theme/dist/images/estate/character-view/holly/32_WhiteHouseGroupShot.png" alt="">
	</div>
</template>

<script>
export default {
	data() {
		return {
			parallax: [
				{
					start: 24400,
					end: 25000,
					fromStyle: { transform: 'translateX(-55%) translateY(-250%) rotate(5deg)', marginTop: '0px' },
					toStyle: { transform: 'translateX(-55%) translateY(-54%) rotate(0deg)', marginTop: '1px' },
					easing: 'linear'
				},
				{
					start: 25500,
					end: 25700,
					fromStyle: { transform: 'translateX(-55%) translateY(-54%) rotate(0deg)' },
					toStyle: { transform: 'translateX(-55%) translateY(-54%) rotate(0deg)', opacity: '0' },
					easing: 'linear'
				},
			]
		}
	},
}
</script>

<style lang="scss" scoped>
.finish {
	position: absolute;
	top: 50%;
	left: 50%;
	max-width: 850px;
	width: 100%;
	transition: all 0.7s linear;
	z-index: 2;
}
</style>
